var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9203 2.94677L12.7069 10.4268H9.49359C8.96026 10.4268 8.44026 10.4668 7.93359 10.5734L9.26693 7.37343L9.32026 7.25343L9.40026 7.0401C9.44026 6.94677 9.46693 6.86677 9.50693 6.8001C11.0536 3.21343 12.7869 2.09343 15.9203 2.94677Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9735 10.7868L24.9468 10.7734C24.1468 10.5468 23.3335 10.4268 22.5068 10.4268H14.1602L17.1602 3.45344L17.2002 3.36011C17.3868 3.42677 17.5868 3.52011 17.7868 3.58677L20.7335 4.82677C22.3735 5.50677 23.5202 6.21344 24.2268 7.06677C24.3468 7.22677 24.4535 7.37344 24.5602 7.54677C24.6802 7.73344 24.7735 7.92011 24.8268 8.12011C24.8802 8.24011 24.9202 8.34677 24.9468 8.46677C25.1468 9.14677 25.1602 9.92011 24.9735 10.7868Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3863 12.6934C23.7863 12.5201 23.1597 12.4268 22.5063 12.4268H9.493C8.58633 12.4268 7.73299 12.6001 6.93299 12.9468C4.61299 13.9468 2.98633 16.2534 2.98633 18.9334V21.5334C2.98633 21.8534 3.01299 22.1601 3.05299 22.4801C3.34633 26.7201 5.61299 28.9868 9.85299 29.2668C10.1597 29.3068 10.4663 29.3334 10.7997 29.3334H21.1997C26.133 29.3334 28.733 26.9868 28.9863 22.3201C28.9997 22.0668 29.013 21.8001 29.013 21.5334V18.9334C29.013 15.9868 27.053 13.5068 24.3863 12.6934ZM19.333 22.3334H12.6663C12.1197 22.3334 11.6663 21.8801 11.6663 21.3334C11.6663 20.7868 12.1197 20.3334 12.6663 20.3334H19.333C19.8797 20.3334 20.333 20.7868 20.333 21.3334C20.333 21.8801 19.8797 22.3334 19.333 22.3334Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMenu);
export default __webpack_public_path__ + "static/media/wallet-menu.5b3fc175da67463cc7f5c0c04e617ef4.svg";
export { ForwardRef as ReactComponent };